import { FileType, formatBytes, getFileTypeFromExtension } from '../../../utils/fileProcessing';
import CvsIcon from '../../../assets/icons/file-type-cvs.svg';
import DocIcon from '../../../assets/icons/file-type-doc.svg';
import PixIcon from '../../../assets/icons/file-type-pix.svg';
import PdfIcon from '../../../assets/icons/file-type-pdf.svg';
import ZipIcon from '../../../assets/icons/file-type-zip.svg';
import UnknownIcon from '../../../assets/icons/file-type-unknown.svg';
import DownloadAttachmentIcon from '../../../assets/icons/download-attachment.svg';
import { IconButton, Typography } from '@material-ui/core';
import { useStyles } from './AttachmentBox.styles';

interface AttachmentBoxProps {
  fileName: string;
  format?: FileType;
  sizeInBytes: number | null;
  onDownload?: () => void;
}

const getIconFormat = (fileName: string, format?: FileType) => {
  let iconFormat: FileType | null = null;

  if (format) {
    iconFormat = format;
  } else {
    const extension = fileName.split('.').pop();
    if (extension) {
      iconFormat = getFileTypeFromExtension(extension);
    }
  }
  return iconFormat;
};

const getIcon = (format: FileType | null): string => {
  if (!format) {
    return UnknownIcon;
  }
  switch (format) {
    case 'application/pdf':
      return PdfIcon;
    case 'image/jpeg':
      return PixIcon;
    case 'image/png':
      return PixIcon;
    case 'application/zip':
      return ZipIcon;
    case 'application/x-7z-compressed':
      return CvsIcon;
    case 'text/plain':
      return DocIcon;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return PdfIcon;
    default:
      return UnknownIcon;
  }
};

const AttachmentBox: React.FC<AttachmentBoxProps> = ({ fileName, format, sizeInBytes, onDownload }) => {
  const classes = useStyles();

  const iconFormat = getIconFormat(fileName, format);

  return (
    <div className={classes.attachmentBox}>
      <div>
        <img src={getIcon(iconFormat)} style={{ marginLeft: '8px', marginRight: '12px' }} alt="ikona formatu pliku" />
      </div>
      <div style={{ flexGrow: 2 }}>
        <Typography className={classes.fileName}>{fileName}</Typography>
        {sizeInBytes && <Typography className={classes.size}>{formatBytes(sizeInBytes, 1)}</Typography>}
      </div>
      <div>
        <IconButton disableRipple style={{ marginLeft: '8px' }} onClick={onDownload}>
          <img src={DownloadAttachmentIcon} alt="ikona pobierania pliku" />
        </IconButton>
      </div>
    </div>
  );
};

export default AttachmentBox;
